import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'
import { localeData } from 'moment'

export const setLanguage = (language) => {
  let langId

  if (language && language.option) {
    langId = language.option.id
  } else {
    langId = language.id
  }
  return (dispatch) => {
    AxiosInstance.get(`/languages/${langId}`).then((data) => {
      if (data) {
        let formatedData = null
        const languageId = data.id
        const languageName = data.name
        const languageData = data.data
        const languageDefault = data.default
        let dataObject = {}
        Object.entries(languageData).map((item) => {
          const key = item[0]
          dataObject[key] = []
          Object.entries(item[1].labels).map((label) => {
            formatedData = {
              key: label[0],
              value: label[1],
              isDisabled: true,
              categoryName: item[1].name,
            }
            dataObject[key].push(formatedData)
          })
          return dataObject
        })
        const language = {
          languageId: languageId,
          name: languageName,
          data: dataObject,
          default: languageDefault,
          value: languageName,
          label: languageName,
        }

        dispatch({
          type: types.SET_DATA,
          languageId: language.languageId,
          name: language.name,
          data: language.data,
          default: language.default,
        })
        dispatch({ type: types.SELECT_LANGUAGE, selectedLanguage: language })
      }
    })
  }
}

export const getUserLanguage = () => {
  return (dispatch) => {
    AxiosInstance.get(`/languages`).then((data) => {
      let language = []
      Object.entries(data.data).map((item) => {
        const key = item[0]
        language[key] = []
        Object.entries(item[1].labels).map((label) => {
          const labelKey = label[0]
          language[key][labelKey] = label[1]
        })
      })

      let languageData = {
        id: data.id,
        default: data.default,
        name: data.name,
        data: language,
      }

      dispatch({ type: types.SET_LANGUAGE, language: languageData })
      dispatch({
        type: types.SELECT_DEFAULT_LANGUAGE,
        selectedDefaultLanguage: data,
      })
    })
  }
}

export const setUserLanguage = (language) => {
  return (dispatch, getState) => {
    Object.entries(language.option.data).map((item) => {
      const key = item[0]
      language[key] = []
      Object.entries(item[1].labels).map((label) => {
        const labelKey = label[0]
        language[key][labelKey] = label[1]
      })
    })

    let languageData = {
      id: language.id,
      default: language.default,
      name: language.value,
      data: language.option.data,
    }

    dispatch({ type: types.SET_LANGUAGE, language: languageData })
    dispatch({ type: types.SELECT_LANGUAGE, selectedLanguage: language })
  }
}

export const getLanguages = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/languages/all-languages').then((data) => {
      if (data) {
        const languages = []
        data.map((item) => {
          languages.push(item)
          if (item.default === 1) {
            let formatedData = null
            const languageId = item.id
            const languageName = item.name
            const languageData = item.data
            const languageDefault = item.default
            let dataObject = {}
            Object.entries(languageData).map((item) => {
              const key = item[0]
              dataObject[key] = []
              Object.entries(item[1].labels).map((label) => {
                formatedData = {
                  key: label[0],
                  value: label[1],
                  isDisabled: true,
                  categoryName: item[1].name,
                }
                dataObject[key].push(formatedData)
              })
              return dataObject
            })
            const language = {
              languageId: languageId,
              name: languageName,
              data: dataObject,
              default: languageDefault,
            }

            dispatch(setLanguage(item))

            dispatch({
              type: types.SET_DEFAULT_LANGUAGE,
              defaultLanguage: language,
            })
            dispatch({
              type: types.SELECT_DEFAULT_LANGUAGE,
              selectedDefaultLanguage: language,
            })
            dispatch({
              type: types.SELECT_LANGUAGE,
              selectedLanguage: language,
            })
          }
        })
        dispatch({ type: types.SET_SELECT_LANGUAGES, languages })
      }
    })
  }
}

export const getAllLanguages = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/languages/all-languages').then((data) => {
      if (data) {
        const languages = []
        data.map((item) => {
          languages.push(item)
          if (item.default === 1) {
            let formatedData = null
            const languageId = item.id
            const languageName = item.name
            const languageData = item.data
            const languageDefault = item.default
            let dataObject = {}
            Object.entries(languageData).map((item) => {
              const key = item[0]
              dataObject[key] = []
              Object.entries(item[1].labels).map((label) => {
                formatedData = {
                  key: label[0],
                  value: label[1],
                  isDisabled: true,
                  categoryName: item[1].name,
                }
                dataObject[key].push(formatedData)
              })
              return dataObject
            })

            const language = {
              languageId: languageId,
              name: languageName,
              data: dataObject,
              default: languageDefault,
            }

            if (item.id === 1) {
              let defaultLanguage = []
              Object.entries(item.data).map((subItem) => {
                const key = subItem[0]
                defaultLanguage[key] = []
                Object.entries(subItem[1].labels).map((label) => {
                  const labelKey = label[0]
                  defaultLanguage[key][labelKey] = label[1]
                })
              })

              let languageData = {
                id: item.id,
                default: item.default,
                name: item.name,
                data: defaultLanguage,
              }

              dispatch({
                type: types.SET_SYSTEM_DEFAULT_LANGUAGE,
                language: languageData,
              })
            }

            dispatch({
              type: types.SET_DEFAULT_LANGUAGE,
              defaultLanguage: language,
            })
            dispatch({
              type: types.SELECT_DEFAULT_LANGUAGE,
              selectedDefaultLanguage: language,
            })
            dispatch({
              type: types.SELECT_LANGUAGE,
              selectedLanguage: language,
            })
          }
        })
        dispatch({ type: types.SET_SELECT_LANGUAGES, languages })
      }
    })
  }
}

export const onChangeData = (category, key, value, index) => {
  return (dispatch, getState) => {
    const { data } = getState().language

    const filteredItem = data[category].filter((item) => item.key === key)
    filteredItem[0].value = value
    filteredItem[0].isDisabled = false

    const reduceCategoryData = [
      ...data[category].slice(0, index),
      ...data[category].slice(index + 1),
    ]
    const newCategoryData = [
      ...reduceCategoryData.slice(0, index),
      filteredItem[0],
      ...reduceCategoryData.slice(index),
    ]

    dispatch({ type: types.HAS_CHANGES, hasChanges: true })
    dispatch({
      type: types.SET_DATA_VALUES,
      category,
      changedData: newCategoryData,
    })
  }
}

export const onSaveData = () => {
  return (dispatch, getState) => {
    const { data, languageId, languageNameChanged, name } = getState().language
    let editedData = []
    Object.entries(data).map((category) => {
      category[1]
        .filter((filteredItem) => filteredItem.isDisabled === false)
        .map((item) => {
          editedData.push({
            category: category[0],
            key: item.key,
            value: item.value,
          })

          item.isDisabled = true
        })
    })

    return languageNameChanged
      ? AxiosInstance.put(
          `/languages/${languageId}`,
          ({ name: name }, { labels: editedData })
        ).then(() => {
          dispatch({ type: types.HAS_CHANGES, hasChanges: false })
          dispatch({
            type: types.CHANGE_LANGUAGE_NAME_BUTTON,
            languageNameChanged: false,
          })
          dispatch({ type: types.SAVE_ALL, data })
        })
      : AxiosInstance.put(`/languages/${languageId}`, {
          labels: editedData,
        }).then(() => {
          dispatch({ type: types.HAS_CHANGES, hasChanges: false })
          dispatch({ type: types.SAVE_ALL, data })
          dispatch(getUserLanguage())
        })
  }
}

export const onSaveIndividualData = (category, key, value, index) => {
  return (dispatch, getState) => {
    const { data, languageId } = getState().language
    let hasChanges = false
    const filteredItem = data[category].filter((item) => item.key === key)
    filteredItem[0].isDisabled = true

    const reduceCategoryData = [
      ...data[category].slice(0, index),
      ...data[category].slice(index + 1),
    ]
    const newCategoryData = [
      ...reduceCategoryData.slice(0, index),
      filteredItem[0],
      ...reduceCategoryData.slice(index),
    ]

    Object.entries(data).map((category) => {
      category[1]
        .filter((filteredItem) => filteredItem.isDisabled === false)
        .map((item) => {
          item ? (hasChanges = true) : (hasChanges = false)
        })
    })
    dispatch({ type: types.HAS_CHANGES, hasChanges })
    dispatch({
      type: types.SET_DATA_VALUES,
      category,
      changedData: newCategoryData,
    })

    let editedData = []

    editedData.push({
      category: category,
      key: key,
      value: value,
    })

    return AxiosInstance.put(`/languages/${languageId}`, {
      labels: editedData,
    }).then(() => {
      dispatch(getUserLanguage())
    })
  }
}

export const onChangeLanguageName = (name) => {
  return (dispatch) => {
    dispatch({ type: types.HAS_CHANGES, hasChanges: true })
    dispatch({
      type: types.CHANGE_LANGUAGE_NAME_BUTTON,
      languageNameChanged: true,
    })
    dispatch({ type: types.SET_NEW_LANGUAGE, newLanguageName: name })
  }
}

export const onSaveLanguageName = (name) => {
  return (dispatch, getState) => {
    const { languageId } = getState().language
    AxiosInstance.put(`/languages/${languageId}`, { name: name }).then(() => {
      dispatch({ type: types.SET_NEW_LANGUAGE, newLanguageName: null })
      dispatch({ type: types.HAS_CHANGES, hasChanges: false })
      dispatch({
        type: types.CHANGE_LANGUAGE_NAME_BUTTON,
        languageNameChanged: false,
      })
    })
  }
}

export const onCancelChanges = () => {
  return (dispatch) => {
    dispatch({ type: types.HAS_CHANGES, hasChanges: false })
    dispatch({ type: types.SET_NEW_LANGUAGE, newLanguageName: null })
    dispatch({
      type: types.CHANGE_LANGUAGE_NAME_BUTTON,
      languageNameChanged: false,
    })
    dispatch(getLanguages())
  }
}

export const toggleNewLanguageOverlay = () => {
  return (dispatch, getState) => {
    const { overlayIsShowing } = getState().language
    dispatch({
      type: types.TOGGLE_OVERLAY,
      overlayIsShowing: !overlayIsShowing,
    })
  }
}

export const toggleLabelOverlay = () => {
  return (dispatch, getState) => {
    const { labelOverlayIsShowing } = getState().language
    dispatch({
      type: types.TOGGLE_LABEL_OVERLAY,
      labelOverlayIsShowing: !labelOverlayIsShowing,
    })
  }
}

export const onChangeNewLanguageName = (name) => {
  return (dispatch) => {
    dispatch({ type: types.SET_NEW_LANGUAGE, newLanguageName: name })
  }
}

export const onChangeNewLabelKey = (newLabelKey) => {
  return (dispatch) => {
    dispatch({ type: types.SET_NEW_LABEL_KEY, newLabelKey })
  }
}
export const onChangeNewLabelValue = (newLabelValue) => {
  return (dispatch) => {
    dispatch({ type: types.SET_NEW_LABEL_VALUE, newLabelValue })
  }
}

export const addNewLanguage = () => {
  return (dispatch, getState) => {
    const { newLanguageName } = getState().language
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language.data)
      : null
    if (!newLanguageName) {
      alert(language.alerts ? language.alerts.type_language_name : null)
      return
    }

    AxiosInstance.post('/languages', {
      name: newLanguageName,
    }).then(() => {
      dispatch({ type: types.TOGGLE_OVERLAY, overlayIsShowing: false })
      dispatch({ type: types.SET_NEW_LANGUAGE, newLanguageName: null })
      dispatch(getLanguages())
    })
  }
}

export const addNewLabel = () => {
  return (dispatch, getState) => {
    const { newLabelKey, newLabelValue, selectedLabel } = getState().language
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language.data)
      : null
    if (!selectedLabel) {
      alert(language.alerts ? language.alerts.select_category : null)
      return
    }

    if (!newLabelKey) {
      alert(language.alerts ? language.alerts.type_label_key : null)
      return
    }

    if (!newLabelValue) {
      alert(language.alerts ? language.alerts.type_label_value : null)
      return
    }

    let newLabel = {
      category: selectedLabel.name,
      key: newLabelKey,
      value: newLabelValue,
    }

    dispatch(toggleLabelOverlay())
    dispatch({ type: types.SET_NEW_LABEL_VALUE, newLabelValue: null })
    dispatch({ type: types.SET_NEW_LABEL_KEY, newLabelKey: null })
    dispatch({ type: types.SET_LABEL_CATEGORY, selectedLabel: null })

    // AxiosInstance.post('/languages', {
    //   name: newLanguageName
    // }).then(() => {
    //   dispatch({type: types.TOGGLE_OVERLAY, overlayIsShowing: false})
    //   dispatch({type: types.SET_NEW_LANGUAGE, newLanguageName: null})
    //   dispatch(getLanguages())
    // })
  }
}

export const setLabelCategory = (label) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_LABEL_CATEGORY, selectedLabel: label })
  }
}
